import React, { useState, useEffect } from 'react';
import arrow_down from '../../../../images/icons/arrow_down.svg';
import styles from './Seller.module.css';
import self_Employed from '../../../../images/icons/self_Employed.svg';
import radio_icon from '../../../../images/icons/UserKycIcons/radio_icon.svg';

function CommonSellerProfession({
  sendUrl,
  sendloanType,
  randomColor,
  handleSelectData,
  showRadio,
  serialNo
}) {
  const { each_box, text, img_align, show_radio } = styles;
  return (
    <div>
      <div>
        <div
          className={`hidden md:block ${
            showRadio === serialNo ? 'visible' : 'invisible'
          }`}
        >
          <img src={radio_icon} alt="" className={`${show_radio}`} />
        </div>
        <div
          onClick={() => {
            handleSelectData();
          }}
          className={`${each_box} mb-4 cursor-pointer hover:shadow-lg`}
          style={{
            backgroundColor: randomColor.bgcolor,
            boxShadow: showRadio === serialNo ? `2px 2px 8px #010C47` : ''
          }}
        >
          <img src={sendUrl} alt="" className={`${img_align}`} />
          <p
            className={`${text} md:text-center`}
            style={{
              color: randomColor.textcolor
            }}
          >
            {sendloanType}
          </p>
          <img className src={arrow_down} alt="" className="md:hidden" />
        </div>
      </div>
    </div>
  );
}
export default CommonSellerProfession;
